import React, { useMemo } from 'react';
import { Popover } from 'antd';
import { FaColumns } from "react-icons/fa";
import { useSelector, useDispatch } from 'react-redux';
import ColumnPicker from './ColumnPicker';
import { setSelectedColumns } from 'redux/columnsPicker/actions';

const withColumnPicker = (WrappedTable) => {
  return ({
    columns,
    hiddenColumns = [],
    showColumnPicker = false,
    emptyColumnName,
    disabledColumns,
    tableId = 'default',
    showScrollBar = false,
    ...rest
  }) => {
    const dispatch = useDispatch();

    const selectedColumns = useSelector((state) =>
      state.tableConfig.selectedColumns[tableId] || []
    );

    const visibleColumns = useMemo(() => {
      if (showColumnPicker) {
        return columns.filter(col =>
          selectedColumns.length > 0
            ? selectedColumns.includes(col.dataIndex || col.title)
            : !hiddenColumns.includes(col.dataIndex)
        );
      }
      return columns; 
    }, [columns, selectedColumns, hiddenColumns, showColumnPicker]);

    const handlePickerChange = (updatedColumns) => {
      dispatch(setSelectedColumns(tableId, updatedColumns));
    };

    return (
      <>
        {showColumnPicker && (
          <div className="tbl-show-hide-col" title="Column Chooser">
            <Popover
              placement="bottom"
              content={
                <ColumnPicker
                  columns={columns}
                  hiddenColumns={hiddenColumns}
                  onChange={handlePickerChange}
                  emptyColumnName={emptyColumnName}
                  disabledColumns={disabledColumns}
                  selectedColumns={selectedColumns}
                />
              }
              trigger="click"
            >
              <FaColumns style={{ width: '25px', height: '25px', cursor: 'pointer', fill: '#8d9399' }} />
            </Popover>
          </div>
        )}
         <div className={showScrollBar ? 'scrollTableWrapper' : 'tblWrapper'} >
        <WrappedTable
          {...rest}
          columns={visibleColumns}
          {...(showScrollBar && { scroll: { x: 'max-content'}})}
        />
        </div>
      </>
    );
  };
};

export default withColumnPicker;
